export enum PurchasesRoute {
  empty = '',
  receipts = 'receipts',
  expenseReports = 'expense-reports',
  advancedExpenses = 'advanced-expenses'
}
